import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import DepositService from './../../services/DepositService';
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';
import { FaInfoCircle } from 'react-icons/fa';

export default function SendToWarehouseModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    unregister,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [depositList, setDepositList] = useState([]);
  const [sapAlternativo, setSapAlternativo] = useState(false);
  const [slaEstrategico, setSlaEstrategico] = useState(false);
  const [loading, setLoading] = useState(true);

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const handleAtualizadoSGRSChange = (event) => {
    setAtualizadoSGRS(event.target.checked);
  };


  useEffect(() => {
    async function fetchRequest() {
      setLoading(true);
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      const deposits = await DepositService.getDeposits();
      setDepositList(deposits);
      setLoading(false);
    }
  
    fetchRequest();
  }, [isModalOpen, requestId]);

  useEffect(() => {
    if (!loading && requestObject && depositList) {
      setValue('drsAtender', requestObject?.request?.drsAtender?._id || requestObject?.request?.drsOriginal._id);
      setValue('quantidadeAtendimento', requestObject?.request?.codItemsAtendidos.length > 0 ? requestObject?.request?.quantidadeRestaAtender : requestObject?.request?.quantidadeAtender);
      setValue("slaEstrategico", false);
    }
  }, [depositList, loading, requestObject, setValue]);

  const onSubmit = async (data) => {
    console.log(data);

    data = { ...data, status: "DEPOSITO" };

    const response = await RequestService.updateParcial(requestId, data);

    if (response) {
      toast.success("Enviado para Depósito!");
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setAtualizadoSGRS(false);
    reset();
  };

  const handleSapAlternativo = (event) => {
    setSapAlternativo(event.target.checked);
  };

  const handleSlaEstrategico = (event) => {
    const isChecked = event.target.checked;
    setSlaEstrategico(event.target.checked);
    setValue("slaEstrategico", event.target.checked);

    if (!isChecked) {
      unregister("drsEstrategico"); // Remove o campo do payload do formulário
    }
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div 
          className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">

                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 items-center text-white text-xl font-bold">
                    <MdSend />
                    ENVIAR PARA DEPÓSITO
                  </div>

                  {requestObject?.request?.isReplica &&
                    <div>
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                </div>

                <div className="ms-4 flex justify-between gap-3">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divContato={true}/>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-4">

                    
                    {/* <div className="flex flex-col items-start gap-1 w-full">
                      <div className="flex w-full justify-between">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          SAP Alternativo
                        </label>
                        <div className="flex gap-2">
                          <label className="text-gray-700 whitespace-nowrap">
                            Sap Alternativo?
                          </label>
                          <input
                            id="usarDoc"
                            type="checkbox"
                            checked={sapAlternativo}
                            onChange={handleSapAlternativo}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                        </div>
                      </div>
                      <input
                        disabled={!sapAlternativo}
                        type="text"
                        {...register("codSapAlternativo", {required:  sapAlternativo ? true : false,})}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 disabled:bg-gray-200
                          ${
                            errors?.codSapAlternativo?.type === "required" && sapAlternativo
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                      />
                      {errors?.codSapAlternativo?.type === "required" && sapAlternativo && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div> */}
                    
                    
                    <div className="flex flex-col items-start gap-1 w-full">
                      <div className="flex w-full justify-between">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          DRS a atender:
                        </label>
                        <div className="flex gap-1 items-center">
                          <label className="text-gray-700 whitespace-nowrap">
                            Ativar SLA estratégico?
                          </label>
                          <div className="relative group">
                            <FaInfoCircle size={15} className="text-gray-500 cursor-pointer" />
                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:flex bg-gray-800 text-white text-xs rounded-md px-2 py-1 shadow-lg w-52 text-center">
                              Se marcado ele não recalcula o SLA ao enviar para Depósito. Ou seja o SLA é calculado a partir do Depósito Original, mesmo que seja atendido por outro.
                            </div>
                          </div>
                          <input
                            id="slaEstrategico"
                            type="checkbox"
                            checked={slaEstrategico}
                            onChange={handleSlaEstrategico}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                          { slaEstrategico && 
                          <select
                          defaultValue="0"
                          {...register("drsEstrategico", {
                            validate: (value) => {
                              if (slaEstrategico) {
                                return value !== "0" || "Depósito para SLA estratégico é obrigatório";
                              }
                              return true; // Não valida se `slaEstrategico` não estiver marcado
                            },
                          })}
                          className={`block w-32 rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${
                              errors?.drsEstrategico?.type === "validate"
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                        >
                          <option value="0" disabled>
                            Escolha um depósito para cálculo do SLA
                          </option>
                          {depositList?.deposits?.map((deposit) => (
                              <option key={deposit._id} value={deposit._id}>
                                  {deposit.cidade} - {deposit.sigla}
                              </option>
                          ))}
                        </select>
                        }
                        {errors?.drsEstrategico?.type === "validate" && (
                          <p className="text-red-500 text-xs whitespace-nowrap">
                            Depósito para SLA estratégico é obrigatório
                          </p>
                        )}
                          
                        </div>
                      </div>
                        <select
                          // defaultValue="0"
                          {...register("drsAtender", {
                            validate: (value) => {
                              return value !== "0";
                            },
                          })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${
                              errors?.drsAtender?.type === "validate"
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                        >
                          <option value="0" disabled>
                            Escolha um depósito que vai atender
                          </option>
                          {depositList?.deposits?.map((deposit) => (
                              <option key={deposit._id} value={deposit._id}>
                                  {deposit.cidade} - {deposit.sigla}
                              </option>
                          ))}
                        </select>
                        {errors?.drsAtender?.type === "validate" && (
                          <p className="text-red-500 text-xs whitespace-nowrap">
                            Depósito a atender é obrigatório
                          </p>
                        )}
                      </div>

                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Endereço no depósito
                      </label>
                      <input
                        type="text"
                        {...register("localizacaoPrateleira", {
                          required: true,
                        })}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                        ${
                          errors?.localizacaoPrateleira?.type === "required"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                        }
                        `}
                      />
                      {errors?.localizacaoPrateleira?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    <div className="flex flex-row gap-2 w-full">
                    
                      <div className="flex flex-col items-start gap-1 mb-4 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                        <textarea
                          {...register("obsAtualizacao", { 
                            // required: true
                           })}
                          className={`
                                w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                                text-neutral-600 font-normal font-['Work Sans']
                                focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                placeholder:text-neutral-400 placeholder:font-normal
                                ${
                                  errors?.obsAtualizacao?.type === "required" ?
                                  "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                          placeholder={"Observação"}>
                        </textarea>
                        {errors?.obsAtualizacao?.type === "required" && (
                          <p className="text-red-500 text-xs whitespace-nowrap">
                            Campo obrigatório
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col items-start gap-1 mb-4 w-full">
                        <div className="flex gap-1 text-gray-700">
                          <FaStamp />
                          <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo:</label>
                        </div>
                        <textarea
                          {...register("carimbo", { 
                            // required: true 
                          })}
                          className={`
                                w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                                text-neutral-600 font-normal font-['Work Sans']
                                focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                placeholder:text-neutral-400 placeholder:font-normal
                                ${
                                  errors?.carimbo?.type === "required" ?
                                  "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                          placeholder={"Observação"}>
                        </textarea>
                        {errors?.carimbo?.type === "required" && (
                          <p className="text-red-500 text-xs whitespace-nowrap">
                            Campo obrigatório
                          </p>
                        )}
                      </div>

                    </div>

                    {requestObject?.request?.isReplica &&
                      <div className="flex gap-2">
                        <input
                          type="checkbox"
                          checked={atualizadoSGRS}
                          onChange={handleAtualizadoSGRSChange}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Confirmo que já atualizei no SGRS
                        </label>
                      </div>
                    }

                    <button
                      disabled={!requestObject?.request?.isReplica ? false : atualizadoSGRS ? false : true}
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full text-sm bg-blue-500 text-white py-2 rounded-2xl hover:bg-blue-600 mt-4 disabled:bg-gray-200"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
